import type { EggGameCardCharacter } from '@/partners/lingo/lingo-giveaway/types/egg-game'
import Mav1Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav1.png'
import Mav2Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav2.png'
import Mav3Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav3.png'
import Mav4Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav4.png'
import Mav5Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav5.png'
import Mav6Img from '@/partners/lingo/lingo-giveaway/assets/images/characters/mav6.png'
import { GACHA_PRIZE } from '@/partners/lingo/lingo-giveaway/types/shared/gacha'

export const goldCharacterId = 'm_gold'
export const gameCharacters: EggGameCardCharacter[] = [
  {
    id: GACHA_PRIZE.MAVERICK1,
    index: 0,
    name: 'McMav',
    image: Mav1Img,
  },
  {
    id: GACHA_PRIZE.MAVERICK2,
    index: 1,
    name: 'Mav wif Hat',
    image: Mav2Img,
  },
  {
    id: GACHA_PRIZE.MAVERICK3,
    index: 2,
    name: 'Captain Mav',
    image: Mav3Img,
  },
  {
    id: GACHA_PRIZE.MAVERICK4,
    index: 3,
    name: 'The Mavfather',
    image: Mav4Img,
  },
  {
    id: GACHA_PRIZE.MAVERICK5,
    index: 4,
    name: 'Satoshi Mav',
    image: Mav5Img,
  },
  {
    id: goldCharacterId,
    index: 5,
    name: 'Dubai Mav',
    image: Mav6Img,
  },
]